export default __webpack_public_path__ + "static/media/fileImage.119220cb.svg";